// export function concatClass(a, b) {
//   if (a && a.indexOf(b) > -1) return a
//   return a ? (b ? a + ' ' + b : a) : b || ''
// }

import { getCollectToolUrl, getCheckToolUrl } from '@/api/collect'

export function downloadTool(url) {
  let path = new URL(url).pathname
  let fileName = path.split('/').pop()
  let element = document.createElement('a')
  element.href = url
  element.download = fileName
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

export function isDeepEqual(obj1, obj2) {
  if (Array.isArray(obj1) && Array.isArray(obj2)) {
    if (obj1.length !== obj2.length) {
      return false
    }
    for (let i = 0; i < obj1.length; i++) {
      if (!isDeepEqual(obj1[i], obj2[i])) {
        return false
      }
    }
    return true
  }
  if (obj1 === obj2) {
    return true
  }

  if (typeof obj1 !== typeof obj2) {
    return false
  }

  if (obj1 && obj2 && typeof obj1 === 'object' && typeof obj2 === 'object') {
    const keys1 = Object.keys(obj1)
    const keys2 = Object.keys(obj2)
    if (keys1.length !== keys2.length) {
      return false
    }
    for (const key of keys1) {
      if (!keys2.includes(key) || !isDeepEqual(obj1[key], obj2[key])) {
        return false
      }
    }
    return true
  }

  return false
}

export function downloadFile(url) {
  let element = document.createElement('a')
  element.href = url
  element.target = '_blank'
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

export function getCollectTool() {
  getCollectToolUrl().then(res => {
    let url = res.data.content
    if (url !== '') {
      downloadTool(url)
    }
  })
}

export function getCheckTool() {
  getCheckToolUrl().then(res => {
    let url = res.data.content
    if (url !== '') {
      downloadTool(url)
    }
  })
}
